import { Code } from './index';

export const CustomCode = Code.extend({
   addKeyboardShortcuts() {
      return {
         'Mod-e': () => this.editor.commands.toggleCode(),
         'Mod-`': () => this.editor.commands.toggleCode(),
      };
   },
   excludes: null,
   priority: 200,
});
